<template>
    <ideo-button
        v-if="notesList.length"
        class="w-100 mt-2"
        @click="notesVisible = !notesVisible"
    >
        <template v-if="notesVisible">{{ $t('[[[Zwiń]]]') }}</template>
        <template v-else>{{ $t('[[[Zgłoszone problemy]]]') }} ({{ notesList.length }})</template>
    </ideo-button>
    <ideo-collapse v-model="notesVisible">
        <ideo-button
            class="w-100 mt-2 d-flex justify-content-between"
            v-for="(note, index) in notesList"
            :key="index"
            :disabled="!note.meta.canEdit"
            variant="primary"
            :to="{ name: 'renter-notes-edit', params: { publicId: note.result.publicId } }"
        >
            {{ note.result.content }}
            <i class="fa-solid fa-arrow-right" />
        </ideo-button>
    </ideo-collapse>
</template>
<script lang="ts">
import { Vue } from 'vue-class-component';
import { Prop } from '@/helpers/Decorators';
import NotesService, { ListItemModel } from '../services/NotesService';
import { Resource } from "@/helpers/Interfaces";

export default class NotesFromTask extends Vue
{
    @Prop() public parentTaskPublicId: string;
    @Prop() public notes: Resource<ListItemModel>[];
    @Prop({ default: false}) public isDisabled: boolean;

    public notesVisible: boolean = false;

    public notesList: Resource<ListItemModel>[] = [];

    public mounted(): void
    {
        this.fetchNotesList();
    }

    public async fetchNotesList(): Promise<void>
    {
        try
        {
            if (this.notes && this.notes.length)
                this.notesList = this.notes;
            else if (!this.isDisabled)
                this.notesList = await NotesService.getNotesFromTask(this.parentTaskPublicId);
        }
        catch (ex)
        {
            this.notesList = [];
            this.$log.debug(ex);
        }
    }
}
</script>
